<template>
  <v-form ref="roleForm" class="form-container">
    <v-card flat class="pa-5 rounded-xl modern-card">
      <v-container fluid class="pa-0">
        <!-- Header Info -->
        <v-row dense class="mb-4">
          <v-col cols="12" class="d-flex align-center">


            <div>
              <div class="subtitle-1 font-weight-bold grey--text text--darken-3 pb-0">
                Información de Categoría
              </div>
              <div class="caption grey--text">
                Gestione los detalles básicos y la organización de esta categoría.
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row dense>
          <!-- Categoria Details -->
          <v-col cols="12" md="8">
            <v-text-field v-model="data.Nombre" :rules="rules.name" label="Nombre de la Categoría" outlined dense
              required prepend-inner-icon="mdi-tag-text-outline" class="rounded-lg mb-2 custom-field"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="data.ordn" @keypress="$pgsHelper.onlyNumber($event, data.ordn)" label="Orden"
              outlined dense prepend-inner-icon="mdi-sort-numeric-ascending" type="number"
              class="rounded-lg mb-2 custom-field" hide-details="auto"></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="data.dscr" label="Descripción" outlined dense rows="2" auto-grow
              prepend-inner-icon="mdi-card-text-outline" class="rounded-lg mb-2 custom-field"
              hide-details="auto"></v-textarea>
          </v-col>

          <v-col cols="12" md="6">
            <v-select v-model="data.Familia" :items="familias" :rules="rules.Familia" item-value="id" item-text="Nombre"
              label="Familia de Producto" outlined dense prepend-inner-icon="mdi-folder-table-outline"
              class="rounded-lg mb-2 custom-field" hide-details="auto"></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete v-model="data.Departamento" :rules="rules.Departamento" label="Departamento"
              :items="modulos" outlined dense prepend-inner-icon="mdi-domain" class="rounded-lg mb-2 custom-field"
              hide-details="auto"></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-autocomplete v-model="data.ZImp" :rules="rules.required" item-text="nomb" item-value="Id"
              label="Zona de Impresión" :items="zonasImpresion" outlined dense prepend-inner-icon="mdi-printer-settings"
              class="rounded-lg mb-2 custom-field" hide-details="auto"></v-autocomplete>
          </v-col>

          <v-col cols="12" class="py-3">
            <div class="switch-container pa-3 rounded-lg border-subtle">
              <v-switch v-model="data.Hide" label="Ocultar esta categoría en el Punto de Venta" color="red darken-2"
                hide-details inset class="mt-0 pt-0"></v-switch>
              <div class="caption grey--text mt-1 pl-12 ml-2">
                Si se activa, no aparecerá en las pantallas de venta.
              </div>
            </div>
            <div class="switch-container pa-3 rounded-lg border-subtle">
              <v-switch v-model="data.oweb" label="Ocultar esta categoría en el Menú Digital" color="red darken-2"
                hide-details inset class="mt-0 pt-0"></v-switch>
              <div class="caption grey--text mt-1 pl-12 ml-2">
                Si se activa, no aparecerá en los menús digitales.
              </div>
            </div>
            <div class="switch-container pa-3 rounded-lg border-subtle">
              <v-switch v-model="data.ocmd" label="Ocultar esta categoría en el Comandero" color="red darken-2"
                hide-details inset class="mt-0 pt-0"></v-switch>
              <div class="caption grey--text mt-1 pl-12 ml-2">
                Si se activa, no aparecerá en los comandero.
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Form Actions -->
        <v-divider class="my-5 grey lighten-3"></v-divider>
        <div class="d-flex justify-end gap-3 align-center actions-footer">
          <v-btn depressed height="46" class="px-6 rounded-lg text-none font-weight-bold grey--text text--darken-1"
            transition="scale-transition" @click="$emit('toggle', false)">
            Volver
          </v-btn>
          <v-btn color="primary" depressed height="46"
            class="px-8 rounded-lg text-none font-weight-bold action-btn ml-3" @click="checkForm">
            <v-icon left size="20">mdi-content-save-check</v-icon>
            Guardar Cambios
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-form>
</template>

<style scoped>
.modern-card {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  background-color: #ffffff !important;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.08) !important;
}

.custom-field {
  transition: all 0.2s ease;
}

.border-subtle {
  border: 1px solid #f0f0f0;
  background-color: #fbfbfb;
}

.switch-container {
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.switch-container:hover {
  background-color: #f5f5f5;
  border-color: #e0e0e0;
}

.action-btn {
  background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%) !important;
  color: white !important;
  box-shadow: 0 4px 15px rgba(46, 125, 50, 0.2) !important;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(46, 125, 50, 0.3) !important;
}

.action-btn:active {
  transform: translateY(0);
}

.gap-3 {
  gap: 12px;
}

/* Deep selections for Vuetify UI refinement */
::v-deep .v-input--outlined>.v-input__control>.v-input__slot {
  background: #fdfdfd !important;
  transition: all 0.2s ease !important;
}

::v-deep .v-input--outlined.v-input--is-focused>.v-input__control>.v-input__slot {
  background: #ffffff !important;
  box-shadow: 0 0 0 4px rgba(46, 125, 50, 0.05) !important;
}

::v-deep .v-textarea .v-input__prepend-inner {
  margin-top: 10px !important;
}
</style>

<script>
export default {
  name: "CategoriasForm",
  components: {},
  props: ["edit", "dataEdit", "familias"],
  data() {
    return {
      zonas: [],
      data: {
        dscr: "",
        Familia: null,
        Departamento: null,
        Nombre: null,
        ordn: 0,
        ZImp: null,
        Hide: null,
        opdv: false,
        oweb: false,
        ocmd: false,
      },
      rules: {
        name: [
          (value) => !!value || "El nombre de la categoría es obligatorio",
        ],
        Familia: [
          (value) =>
            !!value || "La familia de producto es obligatoria",
        ],
        Departamento: [
          (value) =>
            !!value || "El departamento es obligatorio",
        ],
        required: [
          (value) =>
            !!value || "Este campo es obligatorio",
        ],
      },
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.roleForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = { ...this.data };

      if (action === "EDIT") {
        dataSave.Id = this.dataEdit.id;
      }
      dataSave.ordn = Number(dataSave.ordn);
      dataSave.opdv = this.data.Hide;
      this.$emit("successData", dataSave, action);
    },
    /*async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val()) || [];
    },*/
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.zonas = [{ Id: "TICKET-PRINTER", nomb: "Default" }];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.zonas.push(toAdd);
          }
        });
      }
    },
  },
  computed: {
    zonasImpresion() {
      let zonas = [{ Id: "TICKET-PRINTER", nomb: "Default" }];
      this.zonas.forEach((zona) => {
        if (zona.dpto == this.data.Departamento) {
          zonas.push(zona);
        }
      });
      return zonas;
    },
    modulos() {
      let departamentos = this.$store.getters.getPDVDepartamentos;
      return departamentos.map(element => ({ value: element.id, text: element.Nombre }));
    },
  },
  async mounted() {
    //this.getFamilias();
    this.getZonasImpresion();
    if (this.edit) {
      this.data.Nombre = this.dataEdit.Nombre;
      this.data.dscr = this.dataEdit.dscr;
      this.data.Familia = this.dataEdit.Familia;
      this.data.Hide = this.dataEdit.Hide;
      this.data.ZImp = this.dataEdit.ZImp;
      this.data.ordn = this.dataEdit.ordn;
      this.data.opdv = this.dataEdit.opdv;
      this.data.oweb = this.dataEdit.oweb;
      this.data.ocmd = this.dataEdit.ocmd;
      this.data.Departamento = this.dataEdit.Departamento;
    }
  },
};
</script>
